/* This file is autogenerated, see readme.md for instructions */
import PersAlt4SvgIcon from '@bloomreach/banana-theme/icons/pers-alt-4.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PersAlt4Icon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PersAlt4SvgIcon />
    </Icon>
  );
});

PersAlt4Icon.displayName = 'PersAlt4Icon';

export default PersAlt4Icon;
